import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Leave {
  _id: string;
  org: string;
  user: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string;
  };
  reason: string;
  fromDate: string;
  toDate: string;
  leaveType: string;
  reviewedBy: string;
  reviewedByReason: string;
  firstName: string;
  lastName: string;
  status: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export type LeavesResponse = {
  success: boolean;
  message: string;
  data: Leave[];
};

const fetchLeaves = async (): Promise<LeavesResponse> =>
  (await customAxios.get<LeavesResponse>("/leaves/my")).data;

export const useGetLeaves = () =>
  useQuery<LeavesResponse, AxiosError>(["leave"], fetchLeaves, {
    onError: (error) =>
      showNotification({
        title: "Error Loading Leaves",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to load leaves",
        color: "red",
      }),
    staleTime: 1000 * 60 * 5,
    retry: 1,
    refetchOnMount: "always",
  });
